import { cloneDeep, isNumber } from "lodash";
import { ProductBatchItemFromFileUpdatePriceModel } from "./ProductBatchItemFromFileUpdatePriceModel";

interface ColumnInfo {
	pos: number;
	description: string;
}

export class ProductBatchItemFromFileUpdatePriceFormModel {
	skuCode: ColumnInfo|null = null;
	codeSource: ColumnInfo|null = null;
	listPrice: ColumnInfo|null = null;
	sellPrice: ColumnInfo|null = null;
	columnList: ColumnInfo[] = [];
	itemList: ProductBatchItemFromFileUpdatePriceModel[] = [];
	private _rawData: any[][] = [];

	initializeData(arrayFromFile: any[][]):void {
		this._rawData = cloneDeep(arrayFromFile);
		this.columnList = (this._rawData[0] || []).map((col, index) => {
			return {
				pos: index,
				description: col,
			}
		})
		
		this.columnList.forEach((col) => {
			const containsSkuInfo = col.description.toLowerCase().indexOf('sku') > -1;

			const containsCodeSourceInfo = (col.description.toLowerCase().indexOf('codigo') > -1) || 
						       (col.description.toLowerCase().indexOf('código') > -1);

			const containsListPriceInfo = (col.description.toLowerCase().indexOf('de') > -1) ||
						      (col.description.toLowerCase().indexOf('listagem') > -1);						      

			const containsSellPriceInfo = (col.description.toLowerCase().indexOf('por') > -1) ||
						      (col.description.toLowerCase().indexOf('venda') > -1);

			if (containsSkuInfo) {
				this.skuCode = col
			}

			if (containsCodeSourceInfo) {
				this.codeSource = col
			}

			if (containsListPriceInfo) {
				this.listPrice = col
			}
			
			if (containsSellPriceInfo) {
				this.sellPrice = col
			}
		})

		const items = cloneDeep(this._rawData).slice(1);
		const skuCodePos = this.skuCode?.pos == undefined ? null : this.skuCode?.pos
		const codeSourcePos = this.codeSource?.pos == undefined ? null : this.codeSource.pos
		const listPricePos = this.listPrice?.pos == undefined ? null : this.listPrice.pos
		const sellPricePos = this.sellPrice?.pos == undefined ? null : this.sellPrice.pos
		
		for (const item of items) {
			this.itemList.push(new ProductBatchItemFromFileUpdatePriceModel({
				skuCode: isNumber(skuCodePos) ? item[skuCodePos] : null,
				codeSource: isNumber(codeSourcePos) ? item[codeSourcePos] : null,
				listPrice: isNumber(listPricePos) ? item[listPricePos] : null,
				sellPrice: isNumber(sellPricePos) ? item[sellPricePos] : null,
			}))
		}
	}

	updateItemListSkuInfo(skuColInfo: ColumnInfo):void {
		const items = cloneDeep(this._rawData).slice(1);
		const codeSourcePos = this.codeSource?.pos == undefined ? null : this.codeSource.pos
		const listPricePos = this.listPrice?.pos == undefined ? null : this.listPrice.pos
		const sellPricePos = this.sellPrice?.pos == undefined ? null : this.sellPrice.pos

		this.itemList = items.map((list) => {
			return new ProductBatchItemFromFileUpdatePriceModel({
				skuCode: skuColInfo ? list[skuColInfo.pos] : null,
				codeSource: isNumber(codeSourcePos) ? list[codeSourcePos] : null,
				listPrice: isNumber(listPricePos) ? list[listPricePos] : null,
				sellPrice: isNumber(sellPricePos) ? list[sellPricePos] : null,
			})
		})
	}

	updateItemListCodeSourceInfo(codeSourceColInfo: ColumnInfo):void {
		const items = cloneDeep(this._rawData).slice(1);
		const skuCodePos = this.skuCode?.pos == undefined ? null : this.skuCode?.pos
		const listPricePos = this.listPrice?.pos == undefined ? null : this.listPrice.pos
		const sellPricePos = this.sellPrice?.pos == undefined ? null : this.sellPrice.pos

		this.itemList = items.map((list) => {
			return new ProductBatchItemFromFileUpdatePriceModel({
				skuCode: isNumber(skuCodePos) ? list[skuCodePos] : null,
				codeSource: codeSourceColInfo ? list[codeSourceColInfo.pos] : null,				
				listPrice: isNumber(listPricePos) ? list[listPricePos] : null,
				sellPrice: isNumber(sellPricePos) ? list[sellPricePos] : null,
			})
		})
	}

	updateItemListListPriceInfo(listPriceColInfo: ColumnInfo):void {
		const items = cloneDeep(this._rawData).slice(1);
		const skuCodePos = this.skuCode?.pos == undefined ? null : this.skuCode?.pos
		const codeSourcePos = this.codeSource?.pos == undefined ? null : this.codeSource.pos
		const sellPricePos = this.sellPrice?.pos == undefined ? null : this.sellPrice.pos

		this.itemList = items.map((list) => {
			return new ProductBatchItemFromFileUpdatePriceModel({
				skuCode: isNumber(skuCodePos) ? list[skuCodePos] : null,
				codeSource: isNumber(codeSourcePos) ? list[codeSourcePos] : null,
				listPrice: listPriceColInfo ? list[listPriceColInfo.pos] : null,
				sellPrice: isNumber(sellPricePos) ? list[sellPricePos] : null,
			})
		})
	}

	updateItemListSellPriceInfo(sellPriceColInfo: ColumnInfo):void {
		const items = cloneDeep(this._rawData).slice(1);
		const skuCodePos = this.skuCode?.pos == undefined ? null : this.skuCode?.pos
		const codeSourcePos = this.codeSource?.pos == undefined ? null : this.codeSource.pos
		const listPricePos = this.listPrice?.pos == undefined ? null : this.listPrice.pos

		this.itemList = items.map((list) => {
			return new ProductBatchItemFromFileUpdatePriceModel({
				skuCode: isNumber(skuCodePos) ? list[skuCodePos] : null,
				codeSource: isNumber(codeSourcePos) ? list[codeSourcePos] : null,
				listPrice: isNumber(listPricePos) ? list[listPricePos] : null,
				sellPrice: sellPriceColInfo ? list[sellPriceColInfo.pos] : null,
			})
		})
	}

	normalize(): ProductBatchItemFromFileUpdatePriceModel[] {
		return this.itemList
	}

	hasSkuCodeColumn():boolean {
		return !!this.skuCode
	}

	hasCodeSourceColumn():boolean {
		return !!this.codeSource
	}

	hasListPriceColumn():boolean {
		return !!this.listPrice
	}

	hasSellPriceColumn():boolean {
		return !!this.sellPrice
	}

	isValid():boolean {
		return !!this.itemList.length &&
			(!!this.skuCode || !!this.codeSource) && 
			!!this.listPrice &&
			!!this.sellPrice;
	}
}
